// extracted by mini-css-extract-plugin
export default {"Download":"Download_Download__SiI9G","Title":"Download_Title__37a-7"};